var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _circle, _linearGradient4, _circle2, _linearGradient5, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ApplicationWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ptXxEfJsTjPufOlJHBLyia",
    x1: 13.48,
    x2: 31.634,
    y1: 106.407,
    y2: 80.147,
    gradientTransform: "matrix(1 0 0 -1 0 118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7dd8f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45b0d0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ptXxEfJsTjPufOlJHBLyia)",
    d: "M4,38V15h40v23c0,1.1-0.9,2-2,2H6C4.9,40,4,39.1,4,38z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ptXxEfJsTjPufOlJHBLyib",
    x1: 4.614,
    x2: 42.936,
    y1: 110.259,
    y2: 102.467,
    gradientTransform: "matrix(1 0 0 -1 0 118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0077d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b59a2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ptXxEfJsTjPufOlJHBLyib)",
    d: "M44,10v5H4v-5c0-1.1,0.9-2,2-2h36C43.1,8,44,8.9,44,10z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ptXxEfJsTjPufOlJHBLyic",
    x1: 33.751,
    x2: 35.032,
    y1: 107.584,
    y2: 105.731,
    gradientTransform: "matrix(1 0 0 -1 0 118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49bef1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 11.5,
    r: 1.5,
    fill: "url(#ptXxEfJsTjPufOlJHBLyic)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ptXxEfJsTjPufOlJHBLyid",
    x1: 28.751,
    x2: 30.032,
    y1: 107.584,
    y2: 105.731,
    gradientTransform: "matrix(1 0 0 -1 0 118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49bef1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 11.5,
    r: 1.5,
    fill: "url(#ptXxEfJsTjPufOlJHBLyid)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ptXxEfJsTjPufOlJHBLyie",
    x1: 38.751,
    x2: 40.032,
    y1: 107.584,
    y2: 105.731,
    gradientTransform: "matrix(1 0 0 -1 0 118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49bef1"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 11.5,
    r: 1.5,
    fill: "url(#ptXxEfJsTjPufOlJHBLyie)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ApplicationWindow);
export default __webpack_public_path__ + "static/media/icons8-application-window.99ebaa990830be8ce4045acbd788b017.svg";
export { ForwardRef as ReactComponent };